import { BaseEntity } from '../../models';
import { OrigemLancamentoCadastro } from '../../models/origem-lancamento-cadastro';
import { CNAE } from '../cnaes';
import { PessoaCNAESecundaria } from './cnaes-secundarias';
import { PessoaContato, contatoTipoPrincipal } from './contato';
import { PessoaEndereco, enderecoTipoPrincipal } from './endereco';
import { PessoaSocio } from './socios';
import { pessoaJuridica } from './tipo';

export class Pessoa implements BaseEntity {
    id: number;
    idEmpresa: number;
    origemCadastro: number;
    codigo: number;
    tipo: number;
    cnpjCpf: string;
    identificadorMatrizFilial: number;
    cpfResponsavel: string;
    nomeResponsavel: string;
    /** Data de Abertura/Inicio das atividades da empresa */
    dataFundacao: Date;
    dataCadastro: Date;
    nome: string;
    nomeFantasia: string;
    site: string;
    exterior: boolean;

    // Situação Cadastral
    situacaoCadastral: number;
    situacaoCadastralData: Date;
    situacaoCadastralMotivoCodigo: number;
    situacaoCadastralMotivoNome: string;

    // Natureza Juridica
    naturezaJuridicaCodigo: number;
    naturezaJuridicaNome: string;

    // Porte da Empresa
    porteEmpresaCodigo: number;
    porteEmpresaNome: string;

    // CNAEs
    idCNAEPrincipal: number;
    cnaePrincipal: CNAE;
    cnaesSecundarias: PessoaCNAESecundaria[];

    // Contatos
    contatoPrincipal: PessoaContato;
    contatoCobranca: PessoaContato;
    contatoEntrega: PessoaContato;
    outrosContatos: PessoaContato[];
    // Endereços
    enderecoPrincipal: PessoaEndereco;
    enderecoCobranca: PessoaEndereco;
    enderecoEntrega: PessoaEndereco;
    // enderecos: PessoaEndereco[];

    // Capital Social e Quadro de Sócios e Administradores - QSA
    capitalSocial: number;
    socios: PessoaSocio[];

    // Termo LGPD
    statusTermoLGPD: number;
    dataImpressaoTermoLGPD: Date;
    idUsuarioImpressaoTermoLGPD: number;
    dataAnexoTermoLGPD: Date;
    idUsuarioAnexoTermoLGPD: number;
    urlAnexoTermoLGPD: string;

    // Integração ERP
    codigoIntegracaoErp: string;
    idIntegracaoErp: number;
    integradoErp: boolean;
    integracaoErpSistema: number;
    dataIntegracaoErp: Date;
    dataUltimaIntegracaoErp: Date;

    /** Atributos auxiliares */
    // Para o Typeahead de clientes **.
    idCliente: number;
    idRepresentante: number;
    codigoIntegracaoErpRepresentante: string;
    nomeRepresentante: string;
    nomeCidade: string;
    uf: string;
    cadastroCliente: number;
    situacaoCliente: number;
    cadastroCompletoCliente: boolean;
    revisaoStatusCliente: number;
    isentoIpiCliente: boolean;
    dataValidadeCartaIsencaoIpiCliente: Date;
    cartaIsencaoIpiVencidaCliente: boolean;
    rotaEntregaErpSCR: string;
    idPessoa: number;

    constructor(origemCadastro: OrigemLancamentoCadastro) {
        this.origemCadastro = origemCadastro?.id ?? null;
        this.tipo = pessoaJuridica.id;
        this.exterior = false;

        this.contatoPrincipal = new PessoaContato(contatoTipoPrincipal.id);
        this.outrosContatos = [];
        // this.enderecos = [];
        this.enderecoPrincipal = new PessoaEndereco(enderecoTipoPrincipal.id);

        this.cnaesSecundarias = [];
        this.socios = [];
    }
}
